<template>
  <div class="upload-contenter">
    <el-upload
      v-if="isAble"
      ref="upload"
      :action="`${baseURL}/upload/file`"
      :on-success="handleSuccess"
      :on-error="handleError"
      :auto-upload="true"
      :multiple="false"
      :limit="5"
      list-type="picture-card"
      accept=".jpeg,.jpg,.png,.gif,.mp4"
      :file-list="fileList"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-change="handleChange"
      :before-upload="beforeUpload"
      :disabled="!showDel"
    >
      <template #trigger>
        <!-- 上传按钮 -->
        <div class="upload-content">
          <i class="el-icon-plus"></i>
          <span class="up-text">上传</span>
        </div>
      </template>
    </el-upload>
    <div v-else class="disable-space">
      <!-- 模拟禁用状态 -->
      <div class="upload-content">
        <i class="el-icon-plus" style="color: #8c939d"></i>
        <span class="up-text" style="line-height: 20px">上传</span>
      </div>
    </div>
    <!-- 图片预览的弹窗 -->
    <el-dialog :visible.sync="dialogVisible" style="height: 100vh">
      <div style="display: flex; justify-content: center">
        <img style="height: 50%; width: 50%" :src="dialogImageUrl" alt="" />
      </div>
    </el-dialog>

    <!-- 视频预览的弹窗 -->
    <div
      class="custom-dialog"
      v-if="videoDialogVisible"
      @click.stop="videoDialogVisible = false"
    >
      <div class="mask" @click.stop="videoDialogVisible = false"></div>
      <div class="" style="width: 50%">
        <div class="video-content" @click.stop>
          <div class="custom-dialog-title" @click.stop>
            <img
              @click.stop="videoDialogVisible = false"
              src="../../../assets/images/del_icon.png"
            />
          </div>
          <div class="video-space">
            <video
              v-if="dialogVideoUrl"
              :src="dialogVideoUrl"
              controls
              autoplay
              class="video-fullscreen"
            ></video>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="videoDialogVisible" width="20%" top="5vh">
      <div>
        <video controls width="100%" :src="dialogVideoUrl"></video>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { env } from "../../../utils/util.js";
export default {
  name: "uploadFile",
  props: {
    attachmentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isAble: {
      type: Boolean,
      default: true,
    },
    showDel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      baseURL: "",
      fileList: [],
      fileUrl: [],
      dialogImageUrl: "", // 图片预览的URL
      dialogVisible: false, // 控制图片预览弹窗
      dialogVideoUrl: "", // 视频预览的URL
      videoDialogVisible: false, // 控制视频预览弹窗
      maxTotalSize: 30 * 1024 * 1024, // 30 MB
      videoImg: require("@/assets/images/video5.png"),
      attachmentListLength: "",
    };
  },
  watch: {
    fileUrl: {
      handler(newVal) {
        console.log("fileUrl changed:", newVal);
        // this.initImgandVideo();
        const isUrl = /^https?:\/\//;

        let arr = newVal.map((i) => {
          if (isUrl.test(i)) {
            const match = i.match(/\/([^\/?]+)\?/);
            return match ? match[1] : null;
          } else {
            return i;
          }
        });
        // console.log("上传文件组件中的fileChange", [...arr]);
        this.$emit("fileChange", [...arr]);
      },
      deep: true,
    },
    attachmentList: {
      handler(newVal) {
        // console.log("attachmentList changed:", newVal);

        if (newVal.length === 0 || this.attachmentListLength === newVal.length)
          return;
        this.attachmentListLength = newVal.length;

        this.fileUrl = newVal;
        this.fileList = [];
        for (const url of newVal) {
          this.fileList.push({
            name: Date.now() + ".jpg",
            url: url, // 已上传图片的 URL
            status: "success",
            uid: `${Date.now()}_${Math.random()}`,
          });
        }
      },
      // deep: true,
    },
  },
  mounted() {
    const url = env();
    this.baseURL = url.apiUrl;

    this.attachmentListLength = this.attachmentList.length;
    console.log("传入的attachmentList", this.attachmentList);
    this.initImgandVideo();
    // if (this.attachmentList.length > 0) {
    //   // this.fileList = this.attachmentList;
    //   this.fileUrl = this.attachmentList;
    //   for (let url of this.attachmentList) {
    //     if (/\.(mp4)(\?|#|$)/i.test(url)) {
    //       //是否是MP4文件
    //       this.fileList.push({
    //         name: Date.now() + ".jpg",
    //         url: this.videoImg, // 已上传图片的 URL
    //         status: "success",
    //         videoUrl: url,
    //         uid: `${Date.now()}_${Math.random()}`,
    //       });
    //     } else {
    //       this.fileList.push({
    //         name: Date.now() + ".jpg",
    //         url: url, // 已上传图片的 URL
    //         status: "success",
    //         uid: `${Date.now()}_${Math.random()}`,
    //       });
    //     }
    //   }
    // }
  },
  updated() {
    // this.attachmentListLength = this.attachmentList.length;
    // console.log('updated==',this.attachmentListLength,this.attachmentList.length);
  },
  methods: {
    initImgandVideo() {
      if (this.attachmentList.length > 0) {
        // this.fileList = this.attachmentList;
        this.fileList = [];
        this.fileUrl = this.attachmentList;
        for (let url of this.attachmentList) {
          if (/\.(mp4)(\?|#|$)/i.test(url)) {
            //是否是MP4文件
            this.fileList.push({
              name: Date.now() + ".jpg",
              url: this.videoImg, // 已上传图片的 URL
              status: "success",
              videoUrl: url,
              uid: `${Date.now()}_${Math.random()}`,
            });
          } else {
            this.fileList.push({
              name: Date.now() + ".jpg",
              url: url, // 已上传图片的 URL
              status: "success",
              uid: `${Date.now()}_${Math.random()}`,
            });
          }
        }
      }
    },
    beforeUpload(file) {
      // 计算已上传文件总大小，如果没有 size 属性，则假设为 0
      const totalSize = this.fileList.reduce(
        (acc, item) => acc + (item.size || 0),
        0
      );
      console.log("上传前校验文件大小", totalSize + file.size);

      // 判断新文件加入后的总大小是否超过限制
      if (totalSize + file.size > this.maxTotalSize) {
        this.$message.error("总文件大小不能超过 30 MB");
        this.fileList.pop();
        // console.log("超过限制大小处理this.fileList", this.fileList);
        return false; // 阻止上传
      }
      return true; // 允许上传
    },
    handleSuccess(res, file) {
      // 处理上传成功的回调
      console.log("上传成功", file);

      if (res.code === 1000) {
        // console.log("上传成功:", res.data);
        this.fileUrl.push(res.data.filePath);
        // this.fileList.push(res.data.filePath);
      }
    },
    handleError(error, file) {
      console.error("上传失败:", error);
      // console.log("失败的文件:", file);
    },
    handleRemove(file) {
      console.log("handleRemove执行", file);
      console.log("this.fileUrl", this.fileUrl);

      if (file?.response?.data.filePath) {
        this.fileUrl = this.fileUrl.filter((i) => {
          return i != file?.response?.data.filePath;
        });
      } else if (file.videoUrl) {
        this.fileUrl = this.fileUrl.filter((i) => {
          return i != file.videoUrl;
        });
      } else {
        // const url = file.url.match(/\/([^\/?]+)\?/)[1];
        this.fileUrl = this.fileUrl.filter((i) => {
          return i != file.url;
        });
      }

      // console.log("this.fileUrl2", this.fileUrl);
    },
    handleChange(file, fileList) {
      // console.log("文件变化++", file, fileList);
      fileList.forEach(async (item) => {
        if (item.raw && item.raw.type && item.raw.type.startsWith("video")) {
          try {
            const thumbnailBlob = await this.generateVideoThumbnail(item.raw);
            item.url = URL.createObjectURL(thumbnailBlob); // 将生成的缩略图设置为 URL
          } catch (error) {
            console.error("生成视频缩略图时出错:", error);
          }
        }
      });
      this.fileList = [...fileList];
    },
    handlePreview(file) {
      console.log("handlePreview", file);
      if (
        file.videoUrl ||
        file?.raw?.type.includes("video") ||
        file.url.includes(".mp4")
      ) {
        this.dialogVideoUrl =
          file.videoUrl || file?.response?.data?.fileUrl || file.url;
        // this.dialogVideoUrl = file.url;
        this.videoDialogVisible = true;
      } else {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
    },
    // 提取视频第一帧作为缩略图
    generateVideoThumbnail(file) {
      return new Promise((resolve) => {
        const video = document.createElement("video");
        video.src = URL.createObjectURL(file);
        video.crossOrigin = "anonymous";
        video.currentTime = 1; // 设置想要提取的时间帧，通常1秒

        video.addEventListener("loadeddata", () => {
          const canvas = document.createElement("canvas");
          canvas.width = 80; // 设置缩略图的大小
          canvas.height = 80;
          const ctx = canvas.getContext("2d");

          // 绘制视频的第一帧
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          // 加载视频标志图标
          const img = new Image();
          img.src = require("@/assets/images/video1.png"); // 自定义图标路径
          img.onload = () => {
            // 计算图标的居中位置
            const dx = (canvas.width - img.width) / 2 - 10;
            const dy = (canvas.height - img.height) / 2 - 10;

            // 在缩略图上居中绘制图标
            ctx.drawImage(img, dx, dy, 50, 50); // 50x50 为图标大小

            canvas.toBlob(resolve); // 将生成的图像转为 Blob 并返回
          };
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.upload-contenter > div {
  display: flex;
}
.el-dialog__wrapper {
  bottom: auto;
}
.el-upload-list__item-name {
  display: none;
}
::v-deep .el-upload--picture-card {
  width: 80px;
  height: 80px;
  display: flex;
  background-color: #f2f3f5;
}
.up-text {
  font-weight: 500;
  font-size: 14px;
  color: #4e5969;
}
::v-deep .el-upload--picture-card i {
  font-size: 14px;
}
::v-deep .el-upload-list {
  display: flex;
}
::v-deep .el-upload--picture-card {
  line-height: 20px;
  display: flex;
  justify-content: center;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
::v-deep .el-form-item__content {
  display: flex !important;
}
.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.disable-space {
  width: 80px;
  height: 80px;
  background-color: #f2f3f5;
  cursor: not-allowed;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0); /* 半透明背景遮罩 */
  z-index: 2008; /* 让遮罩层位于其他内容之上 */
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* 遮罩背景色 */
  z-index: 2046; /* 避免遮住内容 */
}

.video-content {
  position: relative;
  background-color: #fff;
  padding: 10px;
  // border-radius: 8px;
  // max-width: 50vw;
  // max-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 2057;
}
.custom-dialog-title {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
  img {
    width: 22px;
    cursor: pointer;
  }
}
.video-space {
  display: flex;
  max-width: 45%;
  justify-content: center;
  overflow: auto;
}
.video-fullscreen {
  max-width: 80%;
  // height: 100%;
  object-fit: contain; /* 保持视频宽高比 */
}
</style>